import { PureLightTheme } from "../../../../../styles/theme"
import { COLORS } from "../../../../../styles/variables"

export const CardStyle = {
    padding: 2.5, 
    width: "100%",
}

export const TypStyle = {
    marginBottom: 1,
}

export const RadioGroupStyle = {
    gap: 1,
    [PureLightTheme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "flex-start",
    },
}

export const TagsInputOverlayContainerStyle = {
    position: "relative",
    width: "100%",
}

export const TagsInputMirrorStyle = {
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    overflow: "hidden",
    color: "text.primary",
    font: "inherit",
    lineHeight: "1.4375em",
    padding: "8.5px 14px",
}

export const TagsInputHashStyle = {
    color: COLORS.CERULEAN,
}